import { createSelector } from "reselect";
//EXTRACT THE PART OF THE STATE
const getData = state => state.matches.connected;

const getConnectedMembers = createSelector(getData, connected => connected);

export default getConnectedMembers;



// WEBPACK FOOTER //
// ./src/_selectors/matchesSelectors/getConnectedMembers.js